import React from 'react';

export const Report = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      d="M4.14258 6.99996L6.47591 4.66663L7.80924 5.99996L10.1426 3.66663"
      stroke="currentColor"
    />
    <path d="M3.80908 9.33313H10.4757" stroke="currentColor" />
    <path d="M3.80908 12.0002H10.4757" stroke="currentColor" />
    <path
      d="M9.80925 0.666626H1.14258V15.3333H13.1426V3.99996L9.80925 0.666626Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
